import Container from '@/components/Container';
import ProfileInfo from './info/Info';
import { Suspense } from 'react';
import SubContainer from '@/components/Container/SubContainer';
import { useRoot } from './hooks/useRoot';
import { LoadingContainer } from '../../components/loading-container';
import { ProfilePassword } from './password/Password';
import { BackButton } from '@/components/ui/back-button';
import { DownloadedResources } from './components/DownloadedResources';
import { useResourceHubList } from '@/pages/resource-hub/list/hooks/useResourceHubList';

function ProfileComponent() {
  useRoot();
  useResourceHubList();

  return (
    <>
      <div className="w-full bg-light-green px-4 py-sh-60 md:px-[156px] md:py-[64px]">
        <Container>
          <SubContainer>
            <div className="flex flex-col gap-[13px]">
              <BackButton to="/" label="Back" />
              <ProfileInfo />
            </div>
          </SubContainer>
        </Container>
      </div>
      <Container addMargin>
        <SubContainer>
          <DownloadedResources />
          <ProfilePassword />
        </SubContainer>
      </Container>
    </>
  );
}

export default function ProfilePage() {
  return (
    <Suspense fallback={<LoadingContainer title="Loading profile..." />}>
      <ProfileComponent />
    </Suspense>
  );
}
